import { useQuery } from "react-query";
import TrainingPlansApiClient from "api/TrainingPlansApiClient.js";

export function useRegionTrainingPlans(regionId, payload, options) {
    return useQuery(
        ["trainingPlans", "region", Number(regionId), payload],
        () => TrainingPlansApiClient.getRegionTrainingPlans(regionId, payload),
        options,
    );
}
